"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.586 4H13V2h9v9h-2V5.414l-5.293 5.293-1.414-1.414L18.586 4zM5.414 20H11v2H2v-9h2v5.586l5.293-5.293 1.414 1.414L5.414 20z" }), "Expand");
//# sourceMappingURL=Expand.js.map